import { c as _c } from "react/compiler-runtime";
import { startTransition, useActionState } from "react";
import { isLocalOrDemo } from "@/env-variables/envHelpers";
import { useMockOpprettNarmesteLederAction } from "@/mocks/useMockOpprettNarmesteLederAction";
import type { NarmesteLederInfo } from "@/schemas/nærmestelederFormSchema";
import { opprettNarmesteLeder } from "@/server/actions/opprettNarmesteLeder";
import type { ErrorDetail } from "@/server/narmesteLederErrorUtils";
const initialState = {
  error: null as ErrorDetail | null
};
const action = async (_prev: typeof initialState, {
  values,
  onSuccess,
  onSettled
}: {
  values: NarmesteLederInfo;
  onSuccess?: () => void;
  onSettled?: (state: typeof initialState) => void;
}) => {
  const result = await opprettNarmesteLeder(values);
  const nextState = {
    error: result.success ? null : result.errorDetail
  };
  if (result.success) onSuccess?.();
  onSettled?.(nextState);
  return nextState;
};
const useRealRegistreringAction = () => {
  const $ = _c(4);
  const [t0, runAction, isPending] = useActionState(action, initialState);
  const {
    error
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (values, options) => new Promise(resolve => {
      startTransition(() => runAction({
        values,
        onSuccess: options?.onSuccess,
        onSettled: resolve
      }));
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const startOpprettNarmesteLeder = t1;
  let t2;
  if ($[1] !== error || $[2] !== isPending) {
    t2 = {
      startOpprettNarmesteLeder,
      isPending,
      error
    };
    $[1] = error;
    $[2] = isPending;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2 as const;
};
export const useRegistreringAction = isLocalOrDemo ? useMockOpprettNarmesteLederAction : useRealRegistreringAction;